import type { Router } from 'vue-router'
import { parseRouteLocation } from '@/utils/routeParams'
import { getStandaloneAppKey } from '@/utils/standaloneApp'

const PLATFORM_PREFIX = '/distribution/platform/'
const ROOT_PREFIX = '/distribution/'

/** 是否为可落地的业务页（排除 404 / 纯 redirect 别名） */
function isUsableTarget(router: Router, path: string) {
  const resolved = router.resolve(path)
  const last = resolved.matched[resolved.matched.length - 1]
  if (!last) return false
  if (last.name === '404Page' || last.name === 'NoFound') return false
  const p = last.path
  if (p === '/:pathMatch(.*)*' || p === '/:path(.*)*') return false
  const comps = last.components
  return !!comps && Object.keys(comps).length > 0
}

/**
 * 概况/驾驶舱硬编码跳转兼容：
 * 菜单收拢后叶子为 /distribution/platform/*，
 * 历史缓存或个别 push 仍可能是 /distribution/{leaf}。
 */
function pathCandidates(path: string): string[] {
  const out = [path]
  if (path.startsWith(PLATFORM_PREFIX)) {
    out.push(`${ROOT_PREFIX}${path.slice(PLATFORM_PREFIX.length)}`)
  } else if (
    path.startsWith(ROOT_PREFIX) &&
    !path.startsWith(PLATFORM_PREFIX) &&
    !path.startsWith('/distribution/agency/')
  ) {
    const rest = path.slice(ROOT_PREFIX.length)
    if (rest) out.push(`${PLATFORM_PREFIX}${rest}`)
  }
  return out
}

/** 配送系统页内跳转：解析 query、保留独立窗参数、兼容有无 platform 前缀 */
export function pushDistributionPath(router: Router, rawPath: string) {
  const parsed = parseRouteLocation(rawPath)
  if (!parsed.path) return Promise.resolve()

  const appKey = getStandaloneAppKey()
  const query: Record<string, string> = {}
  if (parsed.query) {
    for (const [k, v] of Object.entries(parsed.query)) {
      if (v === undefined || v === null) continue
      query[k] = Array.isArray(v) ? String(v[0]) : String(v)
    }
  }
  if (appKey) {
    if (query.standalone == null) query.standalone = '1'
    if (query.app == null) query.app = appKey
  }
  const q = Object.keys(query).length ? query : undefined

  for (const path of pathCandidates(parsed.path)) {
    if (isUsableTarget(router, path)) {
      return router.push({ path, query: q })
    }
  }
  return router.push({ path: parsed.path, query: q })
}
